import { render } from "./AutocompleteContacts.vue?vue&type=template&id=7c204a41&scoped=true"
import script from "./AutocompleteContacts.vue?vue&type=script&lang=js"
export * from "./AutocompleteContacts.vue?vue&type=script&lang=js"

import "./AutocompleteContacts.vue?vue&type=style&index=0&id=7c204a41&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c204a41"]])

export default __exports__